import React from 'react'
import { Popper, Box, Typography, Grow, Chip, Tooltip } from '@mui/material'
import PropTypes from 'prop-types'
import { styled } from '@mui/system'
import dayjs from 'dayjs'
import { BiCopy, BiSolidCopy } from 'react-icons/bi'
import { toast } from 'react-toastify'
import { cn } from 'src/lib/utils'

const ArrowBox = styled(Box)(({ theme }) => ({
    position: 'relative',
    backgroundColor: '#fff',
    boxShadow: 'hsl(var(--shadow)) 0px 0px 5px 1px',
    borderRadius: 2,
    maxWidth: 300,
    '&::before': {
        content: '""',
        position: 'absolute',
        top: '5px',
        left: '-10px',
        width: 0,
        height: 0,
        borderTop: '6px solid transparent',
        borderBottom: '6px solid transparent',
        borderRight: '10px solid hsl(var(--primary))'
    }
}))

const NodeDetailsPopper = ({ Compliance, Risk, Governance, anchorEl, handleClose, nodeData, setIsCopy, isCopy }) => {
    const open = Boolean(anchorEl)
    if (!nodeData) return null

    return (
        <Popper
            open={open}
            anchorEl={anchorEl}
            sx={{ minWidth: 200 }}
            placement="right-start"
            modifiers={[
                {
                    name: 'offset',
                    options: {
                        offset: [ 0, 10 ]
                    }
                }
            ]}
            transition
        >
            {({ TransitionProps }) => (
                <Grow {...TransitionProps} timeout={350}>
                    <ArrowBox sx={{ p: 2, gap: 1, display: 'flex', flexDirection: 'column' }}>
                        <div className='flex flex-col gap-1'>
                            <Typography className='whitespace-nowrap overflow-hidden overflow-ellipsi !text-h5' style={{ color: 'hsl(var(--primary))' }} >
                                      Duration
                            </Typography>
                            <Typography className='whitespace-nowrap overflow-hidden overflow-ellipsi !text-subMenu' style={{ width: '100%', color: 'hsl(var(--muted))' }} >
                                {!nodeData.displayName
                                    ? 'N/A'
                                    : dayjs(nodeData?.fromDate)?.year()
                                    // commented because of at present removed
                                    // : dayjs(nodeData?.fromDate)?.year() === dayjs(nodeData?.toDate)?.year()
                                    //     ? dayjs(nodeData?.fromDate)?.year()
                                    //     : `${dayjs(nodeData?.fromDate)?.year()} - ${dayjs(nodeData?.toDate)?.year()}`
                                }
                            </Typography>
                        </div>
                        <div className='flex flex-col gap-1'>
                            <Typography className='whitespace-nowrap overflow-hidden overflow-ellipsi !text-h5' style={{ color: 'hsl(var(--primary))' }} >
                                       Email ID
                            </Typography>
                            <Typography className="whitespace-nowrap overflow-hidden flex !text-subMenu" style={{ width: '100%', color: 'hsl(var(--muted))' }}>
                                {!nodeData.displayName
                                    ? ('N/A')
                                    : (<div className="flex w-full items-center">
                                        <span className={cn(nodeData.emailId?.length >= 23 && 'break-words text-wrap', nodeData.emailId?.length >= 23 ? 'w-[80%]' : 'w-auto')}>{nodeData.emailId}</span>
                                        <Tooltip title="Copy EmailID"placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                            <div> {isCopy.emailId
                                                ? (<BiSolidCopy color="hsl(var(--primary))"style={{ fontSize: '18px', flexShrink: 0 }}className="ml-[10px] cursor-pointer"/>)
                                                : (<BiCopy color="hsl(var(--primary))" style={{ fontSize: '18px', flexShrink: 0 }} className="ml-[10px] cursor-pointer"
                                                    onClick={() => {
                                                        navigator.clipboard.writeText(nodeData?.emailId).then(() => {
                                                            setIsCopy({ ...isCopy, emailId: true })
                                                            toast(<p className="w-[100%] flex flex-row justify-evenly items-center"><BiSolidCopy color="hsl(var(--primary))" /><p>Email id is Copied to clipboard</p></p>,
                                                                { position: 'top-right', autoClose: 5000, hideProgressBar: true, closeButton: false, theme: 'light' })
                                                        })
                                                    }}/>
                                                )}
                                            </div>
                                        </Tooltip>
                                    </div>
                                    )}
                            </Typography>
                        </div>
                        <div className='flex flex-col gap-1'>

                            <Typography className='whitespace-nowrap overflow-hidden overflow-ellipsi !text-h5' style={{ color: 'hsl(var(--primary))' }} >
                                        Phone Number
                            </Typography>
                            <Typography className='whitespace-nowrap overflow-hidden flex overflow-ellipsi !text-subMenu' style={{ width: '100%', color: 'hsl(var(--muted))' }} >
                                {!nodeData.displayName
                                    ? 'N/A'
                                    : nodeData.phoneNumber} {nodeData.displayName && <>{
                                    !isCopy?.phNumber
                                        ? <Tooltip title="Copy Phone Number" placement="right-start" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                            <div><BiCopy color='hsl(var(--primary))'style={{ fontSize: '18px' }} onClick={() =>
                                                navigator.clipboard.writeText(nodeData.phoneNumber)
                                                    .then((data) => {
                                                        setIsCopy({ ...isCopy, phNumber: true })
                                                        toast(<p className='w-[100%] flex flex-row justify-evenly items-center' ><BiSolidCopy color='hsl(var(--primary))'/><p>Phone Number is Copied to clipboard</p></p>, {
                                                            position: 'top-right',
                                                            autoClose: 5000,
                                                            hideProgressBar: true,
                                                            closeButton: false,
                                                            theme: 'light'
                                                        })
                                                    })
                                            } className='ml-[10px] cursor-pointer' />
                                            </div></Tooltip>
                                        : <BiSolidCopy color='hsl(var(--primary))' style={{ fontSize: '18px' }} onClick={() =>
                                            navigator.clipboard.writeText(nodeData.phoneNumber)
                                                .then((data) => {
                                                    setIsCopy({ ...isCopy, phNumber: true })
                                                    toast(<p className='w-[100%] flex flex-row justify-evenly items-center' ><BiSolidCopy color='hsl(var(--primary))'/><p>Phone Number is Copied to clipboard</p></p>, {
                                                        position: 'top-right',
                                                        autoClose: 5000,
                                                        hideProgressBar: true,
                                                        closeButton: false,
                                                        theme: 'light'
                                                    })
                                                })
                                        }
                                        className='ml-[10px] cursor-pointer' />}</>}
                            </Typography>
                        </div>
                        <div className='flex flex-col gap-1'>
                            <Typography className='whitespace-nowrap overflow-hidden overflow-ellipsi !text-h5' style={{ color: 'hsl(var(--primary))' }} >
                                      Role
                            </Typography>
                            <Typography className='whitespace-nowrap flex flex-col overflow-hidden overflow-ellipsi !text-subMenu' style={{ width: '100%', color: 'hsl(var(--muted))' }} >
                                {nodeData.role?.map((data, index) => {
                                    const findColor = (col) => {
                                    // const Governance = [ 'Governance Officer', 'Strategic Manager', 'Governance Analyst' ]
                                    // const Risk = [ 'Model Risk Specalist', 'Risk Manager', 'Risk Analyst', 'Risk Consultant' ]

                                        if (Risk?.includes(col)) {
                                            return 'Risk'
                                        } else if (Governance?.includes(col)) {
                                            return 'Governance'
                                        } else {
                                            return 'Compliance'
                                        }
                                    }
                                    return (
                                        <div key={index}>
                                            {data.length > 12
                                                ? (
                                                    <Tooltip title={data} placement="top"componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                        <div> <Chip style={{ margin: '2px 0px 2px 0px', height: '20px', padding: '2px 0px 0px 0px', color: 'hsl(var(--card))', backgroundColor: `hsl(var(--${findColor(data)}))` }}label={data}/> </div>
                                                    </Tooltip>
                                                )
                                                : (<Chip style={{ margin: '2px 0px 2px 0px', height: '20px', padding: '2px 0px 0px 0px', color: 'hsl(var(--card))', backgroundColor: `hsl(var(--${findColor(data)}))` }} label={data} />
                                                )}
                                        </div>
                                    )
                                })}
                            </Typography>
                        </div>

                    </ArrowBox>

                </Grow>
            )}
        </Popper>
    )
}

NodeDetailsPopper.propTypes = {
    anchorEl: PropTypes.any,
    handleClose: PropTypes.func.isRequired,
    nodeData: PropTypes.object
}

export default NodeDetailsPopper
